import { Dropdown, Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import UserIcon from "../assets/images/user-header.png";
import Image from 'react-bootstrap/Image';

const AuthMenu = () => {
  const navigate = useNavigate();
  const token = localStorage.getItem("token");
  const user = JSON.parse(localStorage.getItem("user"));
  console.log(user)

  const handleLogout = () => {
    localStorage.clear();
    navigate("/");
  };

const isTokenExpired = () => {
  try {
    // Parse ISO string to a Date object
    const expiresAt = new Date(user.expires_at);
    return Date.now() > expiresAt.getTime();
  } catch (e) {
    return true; // invalid token
  }
};


// Clear token if missing or expired
if (!token || isTokenExpired(token)) {
  localStorage.removeItem("token");
  localStorage.removeItem("user");

  return (
    <Button
      className="custom-bttn style-1"
      onClick={() => navigate("/sign-in")}
    >
      Sign In / Register
    </Button>
  );
}

  // Logged in
  return (
    <Dropdown className="user-dropdown" align="end">
      <Dropdown.Toggle id="UseLogin">

<Image
  src={user?.profile_photo || UserIcon}
  roundedCircle
  width={50}
  height={50}
  style={{ objectFit: 'cover' }}

/>       
      </Dropdown.Toggle>

      <Dropdown.Menu>
        <Dropdown.Item href="/saved-homes">Saved Homes</Dropdown.Item>
        {/* <Dropdown.Item href="/saved-searches">Saved Searches</Dropdown.Item> */}
        {/* <Dropdown.Item href="/recently-viewed">Recently Viewed</Dropdown.Item>
        <Dropdown.Item href="/my-agents">My Agents</Dropdown.Item> */}
        <Dropdown.Item href="/profile">Account Setting</Dropdown.Item>
        {/* <Dropdown.Item href="/compare-homes">Compare Home</Dropdown.Item> */}
        <Dropdown.Divider />
        <Dropdown.Item onClick={handleLogout}>
          Sign Out
        </Dropdown.Item>
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default AuthMenu;
